import { FC } from 'react';
import site from 'pro/config/site';

export const AppleWatchHelp: FC = () => {
    return (
        <>
            <h2>Event Timing and Participation Conditions:</h2>
            <p>
                -This event is exclusively available to users in the United States.<br/>
                -Event Period: November 10, 2023, 00:00 PST, to November 29, 2023, 00:00 PST.<br/>
                -To qualify for a free Apple Watch, place a single order with an actual payment of $7,777 or
                more.
            </p>

            <h2>About the Gift:</h2>
            <p>-Apple Watch Series 9 GPS, 45mm Midnight Aluminum Case with Midnight Sport Band - M/L.</p>

            <h2>About Shipping:</h2>
            <p>
                -The Apple Watch will be shipped separately from your order items.<br/>
                -{site.brand}&apos;s customer service representatives will contact you after confirming receipt of
                your order to arrange delivery of the watch.
            </p>

            <h2>About Returns:</h2>
            <p>
                -Items ordered during this event cannot be returned unless there is a quality issue.<br/>
                -Contact customer service for specific return policy details.
            </p>
        </>
    );
};